import React, {useState} from "react";
import {Columns, Modal, Section, Form, Button, Heading} from "react-bulma-components";
import axios from "axios";
import {NotificationManager} from "react-notifications";


export default function CreateNewContactModal({open, setOpen}){
    const defaultContact = {
        additional_contacts: [], // These are needed as create endpoint key scans for them array['key']
        part_contacts: [],
        workshop_contacts: [],
        workshop_instructions: [],
        rental_instructions: [],
        contact_type: "CC",
        display_name: "",
        labour_rate: 40,
        labour_rate_markup: 0,
        partial_contact: true,
        payment_term_days: 0,
        workshop_account_code: "02",
        deposit_account_code: "03",
        hire_account_code: "01",
        part_account_code: "05",
        movement_account_code: "08",
        company_name: "",
        company_phone_type: "Phone",
        company_phone: "",
        company_phone_country_code: "",
        company_phone_area_code: "",
        company_email: ""
    }
    const [contact ,setContact] = useState(defaultContact);

    const phoneTypeOptions = [
      {name: "Landline", value: "Phone"},
      {name: "Mobile", value: "Mobile"},
      {name: "Fax", value: "Fax"}
    ];

    const handleChange = e => {
        let newContact = {...contact};
        newContact[e.target.name] = e.target.value;
        setContact(newContact);
    };

    const validator = () => {
        let valid = true;
        valid = valid && !!contact.display_name;
        valid = valid && !!contact.company_name;
        valid = valid && !!contact.company_email;
        valid = valid && !!contact.company_phone_type;
        valid = valid && !!contact.company_phone;

        if(contact.company_phone_type === "Phone"){
            valid = valid && contact.company_phone_area_code;
        }
        if(contact.company_phone_type !== "Fax"){
            valid = valid && contact.company_phone_country_code;
        }

        return valid;
    }

    const onSave = () => {
        const conf = {
            method: "post",
            data: contact,
            url: "/api/contacts"
        };
        if(validator()) {
            axios(conf).then(res => {
                setOpen(false);
                setContact(defaultContact);
            }).catch(err => {
                NotificationManager.error("There was an error creating contact")
            })
        }
        else{
            NotificationManager.warning("Display Name, Company Name, Company Email and All Company Phone Details are required")
        }
    }

    return (
        <Modal
            show={open}
            onClose={() => setOpen(false)}
            closeOnBlur
        >
            <Modal.Content className={"wider-modal"}>
                <Section style={{background: "white"}}>
                    <Columns>
                        <Columns.Column>
                            <Heading>Create New Partial Contact</Heading>
                        </Columns.Column>
                    </Columns>
                    <Columns>
                        <Columns.Column>
                            <Form.Field className="has-addons">
                              <Form.Control>
                                <Form.Label>Type</Form.Label>
                                <Button
                                  color={contact.contact_type === "CC" ? "primary" : ""}
                                  onClick={() => handleChange({target: {name: "contact_type", value: "CC"}})}
                                >
                                  Customer
                                </Button>
                                <Button
                                  color={contact.contact_type === "SP" ? "primary" : ""}
                                  onClick={() => handleChange({target: {name: "contact_type", value: "SP"}})}
                                >
                                  Supplier
                                </Button>
                              </Form.Control>
                            </Form.Field>
                        </Columns.Column>
                        <Columns.Column>
                            <Form.Label>Display Name</Form.Label>
                            <Form.Input
                                name={"display_name"}
                                value={contact.display_name}
                                onChange={handleChange}
                                type={"text"}
                            />
                        </Columns.Column>
                        <Columns.Column>
                            <Form.Label>Company Name</Form.Label>
                            <Form.Input
                                name={"company_name"}
                                value={contact.company_name}
                                onChange={handleChange}
                                type={"text"}
                            />
                        </Columns.Column>
                        <Columns.Column>
                            <Form.Label>Company Email</Form.Label>
                            <Form.Input
                                name={"company_email"}
                                value={contact.company_email}
                                onChange={handleChange}
                                type={"email"}
                            />
                        </Columns.Column>
                    </Columns>
                    <Columns>
                        <Columns.Column>
                            <Form.Label>Phone Type</Form.Label>
                            <Form.Select
                                name={"company_phone_type"}
                                value={contact.company_phone_type}
                                onChange={handleChange}
                            >
                                {phoneTypeOptions.map((option) => (
                                  <option value={option.value}>{option.name}</option>
                                ))}
                            </Form.Select>
                        </Columns.Column>
                        {contact.company_phone_type !== "Fax" &&
                            <Columns.Column>
                                <Form.Label>Country Code</Form.Label>
                                <Form.Input
                                    name={"company_phone_country_code"}
                                    value={contact.company_phone_country_code}
                                    onChange={handleChange}
                                    type={"text"}
                                />
                            </Columns.Column>
                        }
                        {contact.company_phone_type === "Phone" &&
                            <Columns.Column>
                                <Form.Label>Area Code</Form.Label>
                                <Form.Input
                                    name={"company_phone_area_code"}
                                    value={contact.company_phone_area_code}
                                    onChange={handleChange}
                                    type={"text"}
                                />
                            </Columns.Column>
                        }
                        <Columns.Column>
                            <Form.Label>Phone Number</Form.Label>
                            <Form.Input
                                name={"company_phone"}
                                value={contact.company_phone}
                                onChange={handleChange}
                                type={"text"}
                            />
                        </Columns.Column>
                    </Columns>
                    <Columns>
                        <Columns.Column>
                            <Button
                                color={"success"}
                                fullwidth
                                onClick={onSave}
                            >
                                Create
                            </Button>
                        </Columns.Column>
                        <Columns.Column>
                            <Button
                                color={"info"}
                                fullwidth
                                onClick={() => setOpen(false)}
                            >
                                Cancel
                            </Button>
                        </Columns.Column>
                    </Columns>
                </Section>
            </Modal.Content>
        </Modal>
    )


}